import { useEffect, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { canonicalUrl } from './domains';

/** Also canonicalize client-side navigation, which does not reach CloudFront. */
export function DomainBoundary({ children }: { children: ReactNode }) {
  const location = useLocation();
  const target = canonicalUrl(window.location.hostname, location.pathname, location.search, location.hash);
  useEffect(() => {
    if (target) window.location.replace(target);
  }, [target]);
  return target ? null : children;
}
